import type { ProfileEditorProps } from "../use-profile-settings";
import { sectionLabel, fieldLabel, bodyText } from "./profile-styles";
import { ProfilePicture } from "./profile-picture";
import { ProfileField } from "./profile-field";

export function ProfileAbout({ editor }: ProfileEditorProps) {
  const { profile, writes } = editor;
  return (
    <section
      aria-labelledby="account-about"
      className="flex flex-1 flex-col gap-[24px] border-t border-[rgba(22,22,22,0.13)] pt-[24px]"
    >
      <h2 id="account-about" className={sectionLabel}>
        About you
      </h2>
      <ProfilePicture
        inputId="account-photo"
        src={profile.saved.image}
        initial={profile.name.trim().charAt(0).toUpperCase()}
        changeLabel="Change photo"
        removeLabel="Remove photo"
        disabled={writes.locked}
        busy={writes.busy}
        onPick={profile.updatePhoto}
        onRemove={() => profile.updatePhoto(null)}
        status={writes.notices.photo ?? null}
      />
      <div className="flex flex-col gap-[24px]">
        <ProfileField
          id="account-name"
          label="Name"
          saved={profile.saved.name ?? ""}
          draft={profile.name}
          onDraft={profile.setName}
          onSave={(input) => profile.saveName(input.value)}
          onCancel={() => profile.setName(null)}
          status={writes.notices.name ?? null}
          disabled={writes.locked}
          required
          autoComplete="name"
          maxLength={200}
        />
        <div className="flex flex-col gap-[6px]">
          <span className={fieldLabel}>Email</span>
          <span className={`${bodyText} text-[#161616]`}>
            {profile.saved.email || "No email on file"}
          </span>
          <p className="font-plex-sans text-[12px] leading-[15.6px] text-[#7c7c7c]">
            Your email comes from the account you signed in with, so it cannot
            be edited here. To use another email, sign in with that account.
          </p>
        </div>
      </div>
    </section>
  );
}
